import systemProperties from './maps/systemProperties';
import { property, systemProperty } from 'cosmos-config/generator';

export default [
  ...systemProperties,
  property('displayname'),
  systemProperty('owner'),
];
